import { jsx as _jsx } from "react/jsx-runtime";
export function ExternalLinkLink(param) {
    let { href, children } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: "mt-4 text-[#9667ED] hover:cursor-pointer hover:text-[#9667ED] cursor-pointer hover:underline",
        children: /*#__PURE__*/ _jsx("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            children: children
        })
    });
}
